import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from '@/locales/fr.json';
import { preferences, type Locale } from './preferences';

const loaders: Record<Exclude<Locale, 'fr'>, () => Promise<{ default: object }>> = {
  en: () => import('@/locales/en.json'),
  ar: () => import('@/locales/ar.json'),
};

export async function ensureLocale(locale: Locale) {
  if (locale !== 'fr' && !i18n.hasResourceBundle(locale, 'translation')) {
    i18n.addResourceBundle(locale, 'translation', (await loaders[locale]()).default);
  }
  await i18n.changeLanguage(locale);
}

export async function initI18n() {
  const locale = preferences.get().locale;
  await i18n.use(initReactI18next).init({
    lng: 'fr', fallbackLng: 'fr', resources: { fr: { translation: fr } }, interpolation: { escapeValue: false }, returnNull: false,
  });
  if (locale !== 'fr') await ensureLocale(locale);
  return i18n;
}

export async function setLocale(locale: Locale) {
  await ensureLocale(locale);
  preferences.set({ locale });
}

export default i18n;
